export default "__VITE_ASSET__BUVarNZQ__"